module.exports = __webpack_public_path__ + "img/删除2.cd7c03e0.svg";